import React from "react";
import FormField from "./FormField";

class CheckboxField extends FormField {
    render() {
        const {input, children, meta: {touched, error, warning}, disabled} = this.props;

        return (
            <label className={this.getClassName()}>
                {children}
                <input
                    {...input}
                    type="checkbox"
                    disabled={disabled}
                    ref={checkboxInput => this.checkboxInput = checkboxInput}
                />
                <span
                    className="checkmark"
                    onClick={() => this.checkboxInput.checked}
                />
            </label>
        )
    }
}

export default CheckboxField;